import React from "react";
import { Box, Typography, Stack, LinearProgress } from "@mui/material";

const TopTracks = ({ tracks, played }) => {
  return (
    <Box
      sx={{
        mt: 8,
        mb: 8,
        p: 3,
        boxShadow: "1.5px 2.6px 10px 0px #7777771A",
        maxWidth: "100%",
        width: "100%",
      }}
    >
      <Box display="flex" justifyContent="space-between" marginBottom="10px">
        <Typography fontSize="20px" fontWeight="600" gutterBottom>
          Top 5 Tracks
        </Typography>
        <Typography
          fontSize="18px"
          fontWeight="600"
          gutterBottom
          color="primary"
        >
          Played
        </Typography>
      </Box>

      <Stack spacing={1}>
        {tracks.map((track, index) => (
          <Box key={index}>
            <Box display="flex" justifyContent="space-between">
              <Typography fontSize="12px" fontWeight="600" gutterBottom>
                {track}
              </Typography>
              <Typography
                fontSize="16px"
                fontWeight="600"
                gutterBottom
                color="primary"
              >
                {played[index]}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={Math.floor(Math.random() * 100)}
              sx={{
                height: "10px",
                borderRadius: "5px",
                width: "100%",
                bgcolor: "#F0F0F0",
              }}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default TopTracks;
